<form [formGroup]="form">
  <div class="soft-card">
    <div class="soft-overline">Allgemein</div>
    <div class="">
      <label class="soft-label top">Startup App</label>
      <soft-select formControlName="startup" (valueChange)="set()">
        <soft-select-option [value]="undefined"><span class="text-light">Standard</span></soft-select-option>
        @for (app of apps$ | async; track app.route) {
          <soft-select-option [value]="app.route">{{ app.name | translate }}</soft-select-option>
        }
      </soft-select>
    </div>

    <div class="mt-4">
      <label class="soft-label top">Sprache</label>
      <soft-select [value]="languageService.selected().code"
                   (valueChange)="languageService.setLanguage($event)">
        @for (language of languageService.languages; track language.code) {
          <soft-select-option [value]="language.code">{{ language.name }}</soft-select-option>
        }
      </soft-select>
    </div>
  </div>
</form>
